/**
 * App의 settings index
 */
import config from "./conf";
export { config as conf }
export const debug = config.debug;

export { default as db } from "./db";

export { strings, targetLangs } from "./strings";

